import Form from '@utils/form'

export default new Form('materiel.category')
  // .url('/srmGeneralFormula/addSrmGeneralFormula', process.env.VUE_APP_PURCHASE_API)
  .title('formTitle.baseInfo')
  .add('orgNo')
  .add('groupNo')
  .add('groupName')
  .add('remark')
  .end()
